/**
 * x轴label颜色
 */
export const XAXISLABEL_COLOR = 'black';

/**
 * y轴label颜色
 */
export const YAXISLABEL_COLOR = 'black';

/**
 * legend颜色
 */
export const LEGEND_COLOR = 'rgba(255, 255, 255, 1)';

/**
 * 分隔线颜色
 */
export const SPLITLINE_COLOR = 'rgba(255, 255, 255, 0.1)';

/**
 * 缩放区域选中范围的填充颜色
 */
export const DATAZOOM_FILLERCOLOR = 'rgba(216, 216, 216, 1)';

/**
 * 圆环图颜色显示顺序
 */
export const DOUGHNUT_COLOR = [
  'rgb(255,0,0)',
  'rgb(255,255,0)',
  'rgb(169,208,142)',
  '#3C6371',
  '#294149',
  '#EEEEEE',
];

/**
 * 纵向直方图颜色
 */
export const VERTICAL_BAR_COLOR = 'rgba(125, 211, 33, 1)';

/**
 * 横向直方图颜色
 */
export const HORIZONTAL_BAR_COLOR = 'rgba(131, 203, 208, 1)';

/**
 * 堆叠直方图背景颜色
 */
export const STACKBAR_BG_COLOR = 'rgba(255, 255, 255, 0.1)';


/**
 * 堆叠直方/折线图颜色显示顺序
 */
export const STACK_COLOR = [
  '#45A2CD',
  '#A1D8E6',
  '#BCB4D8',
  '#D8E58D',
  '#9CDC56',
  '#D4BE9D',
  '#FFE082',
  '#FFB987',
  '#F7C8CF',
  '#FFEFEF',
];
